export default __webpack_public_path__ + "static/media/navigation-tabs-specs.02184ff3.png";